import createElement from '../logical-components/createElement';
// Global helpers
import svgs from './svgs';
import renderText from '../logical-components/renderText';
import constructName from '../logical-components/constructName';
var svgTable = {
    Gezin: svgs.family,
    Hobby: svgs.ring,
    Opleiding: svgs.cap,
    Werk: svgs.briefcase,
    Sport: svgs.cap,
    Eten: svgs.eat,
    Muziek: svgs.music,
    Huisdier: svgs.paw,
    Vakantie: svgs.family,
};
var aboutBlock = function (config, section, args) {
    var _a;
    var wrapper = createElement('div', [
        { type: 'class', value: '_mnslq-remeber-ob-text' },
    ]);
    var textToLonger = ((_a = args === null || args === void 0 ? void 0 : args.about) === null || _a === void 0 ? void 0 : _a.length) > 300;
    var expanded = false;
    wrapper.innerHTML = "\n        <h3> ".concat(renderText('rememberMe.over', "".concat(constructName(args))), " </h3>\n        <div class='_msnlq-ab-wrap'>\n            <div class='_msnlq-ab-c'>\n            </div>\n\n            ").concat(textToLonger
        ? "<div class='_msnlq-rdme-btn'> ".concat(!expanded
            ? renderText('rememberMe.about.readMore')
            : renderText('rememberMe.about.readLess'), " \n            </div>")
        : '', "\n        </div>\n        \n    ");
    var render = function () {
        var ele = wrapper.querySelector('._msnlq-ab-c');
        ele.innerHTML = "<p class='_mnslq-rm-ob-tf ".concat(textToLonger && !expanded ? '_msnlq-to-lng' : '', " _mnslq-text'>\n            ").concat(args.about, "\n        </p>");
    };
    render();
    if (textToLonger) {
        var btn_1 = wrapper.querySelector('._msnlq-rdme-btn');
        btn_1.addEventListener('click', function () {
            expanded = !expanded;
            var text = expanded
                ? renderText('rememberMe.about.readLess')
                : renderText('rememberMe.about.readMore');
            btn_1.innerHTML = text;
            render();
        });
    }
    return wrapper;
};
var extraItem = function (data, index, expanded) {
    var wrapper = createElement('div', [
        { type: 'class', value: '_msnlq-grid-item' },
    ]);
    if (!expanded && index >= 4) {
        wrapper.classList.add('_msnlq-h-b-item');
    }
    wrapper.innerHTML = "\n        <div class=\"_msnlq-grid-icon\">\n            ".concat(svgTable[data.icon_name] || svgs.flower, "\n        </div>\n        <div class=\"_msnlq-grid-content\">\n            <p class=\"_msnlq-grid-title\"> ").concat(renderText("variables.rememberMe.blocks.".concat(data.name)), " </p>\n            <p class=\"_msnlq-grid-text\"> ").concat(data.text, " </p>\n        </div>\n    ");
    return wrapper;
};
var extraBlock = function (config, section, data) {
    var expanded = false;
    var wrapper = createElement('div', [
        { type: 'class', value: '_mnslq-remeber-ob-extra' },
    ]);
    wrapper.innerHTML = "\n        <div class='_mnslq-grid--about'></div>\n        <div class='_msnlq-grid-btn'>\n            ".concat(!expanded
        ? renderText('rememberMe.about.blocks.readMore')
        : renderText('rememberMe.about.blocks.readLess'), "\n        </div>\n    ");
    // Render items
    var render = function () {
        var container = wrapper.querySelector('._mnslq-grid--about');
        container.innerHTML = '';
        data.extra.forEach(function (item, index) {
            container.appendChild(extraItem(item, index, expanded));
        });
    };
    render();
    // Handle button and click
    var btn = wrapper.querySelector('._msnlq-grid-btn');
    btn.addEventListener('click', function () {
        expanded = !expanded;
        var text = expanded
            ? renderText('rememberMe.about.blocks.readLess')
            : renderText('rememberMe.about.blocks.readMore');
        btn.innerHTML = text;
        render();
    });
    return wrapper;
};
// Visual component wrapper
var rememberMeAbout = function (config, section, data) {
    var _a, _b;
    var aboutWrapper = createElement('div', [
        { type: 'class', value: '_mnslq-remeber-ob' },
    ]);
    if ((_a = data === null || data === void 0 ? void 0 : data.about) === null || _a === void 0 ? void 0 : _a.length) {
        aboutWrapper.appendChild(aboutBlock(config, section, data));
    }
    if ((_b = data === null || data === void 0 ? void 0 : data.extra) === null || _b === void 0 ? void 0 : _b.length) {
        aboutWrapper.appendChild(extraBlock(config, section, data));
    }
    return aboutWrapper;
};
export default rememberMeAbout;
